import { GET_ATTENDANCE_GROUPS } from '../../mutation-types';

const mutations = {
  [GET_ATTENDANCE_GROUPS](state, groups) {
    state.groupList = groups;
  },
};

export default mutations;
